export default "__VITE_ASSET__Dp_FGxH8__"